define('viewmodels/modals/alerts/ErrorAlert',[], function () {

    var ErrorAlert = function(dialog, title, message) {
        this.dialog = dialog;
        this.title = title;
        this.message = message;
    };

    ErrorAlert.prototype.close = function() {
        this.dialog.close(this);
    };

    ErrorAlert.prototype.show = function () {
        return this.dialog.showAlert(this);
    };

    return ErrorAlert;
});


